export const SET_NOTIFICATIONS_STATE = 'SET_NOTIFICATIONS_STATE'
export const SET_TOGGLEABLE_FIELDS = 'SET_TOGGLEABLE_FIELDS'
export const SET_OMITTED_FIELDS = 'SET_OMITTED_FIELDS'
export const SET_SIDEBAR_PLAYLISTS_FAVOURITES =
  'SET_SIDEBAR_PLAYLISTS_FAVOURITES'

export const setNotificationsState = (enabled) => ({
  type: SET_NOTIFICATIONS_STATE,
  data: enabled,
})

export const setToggleableFields = (obj) => ({
  type: SET_TOGGLEABLE_FIELDS,
  data: obj,
})

export const setOmittedFields = (obj) => ({
  type: SET_OMITTED_FIELDS,
  data: obj,
})

export const setSidebarPlaylistsOnlyFavourites = (enabled) => ({
  type: SET_SIDEBAR_PLAYLISTS_FAVOURITES,
  data: enabled,
})
